// GenderSelector.jsx
import React, { useEffect, useState } from "react";
import { Form } from "antd";

const GenderSelector = ({ onChange, defaultValue, reset, setReset }) => {
  const [selectedGender, setSelectedGender] = useState(defaultValue || null);
  const genderOptions = ["Male", "Female"];

  const toggleGender = (gender) => {
    const newSelectedGender = selectedGender === gender ? null : gender;
    setSelectedGender(newSelectedGender);
    if (onChange) {
      onChange(newSelectedGender);
    }
    if (setReset) setReset(false);
  };

  useEffect(() => {
    if (reset) {
      setSelectedGender(null);
    }
  }, [reset]);

  return (
    <div className="gender-selector-container">
      <Form.Item label="Gender (optional)" className="gender-selector-title">
        <div className="gender-options-container">
          {genderOptions.map((gender) => (
            <div
              key={gender}
              onClick={() => toggleGender(gender)}
              className={`gender-option ${
                selectedGender === gender ? "selected" : ""
              }`}
            >
              {gender}
            </div>
          ))}
        </div>
      </Form.Item>
    </div>
  );
};

export default GenderSelector;
